import React from 'react'
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	Box,
	Typography,
} from '@mui/material'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import { SeasonType } from '@schemas'
import { grey, orange } from '@mui/material/colors'
import dayjs from 'dayjs'

interface PropsType {
	open: boolean
	season: SeasonType | null
	onClose: () => void
}

/**
 * 판매 기간 밖의 시즌을 열려고 할 때.
 *
 * 강행 버튼을 두지 않는다 — 시즌은 날짜에 맞아야만 시작된다.
 * (SEASON_OPEN_PLAN.md §6.1)
 */
export const SeasonOpenPeriodWarningModal = (props: PropsType) => {
	const { open, season, onClose } = props

	return (
		<Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
			<DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
				<WarningAmberIcon sx={{ color: orange[700] }} />
				판매 기간이 아닙니다
			</DialogTitle>

			<DialogContent>
				<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 2 }}>
					<Box sx={{ display: 'flex', gap: 2 }}>
						<Typography sx={{ width: '7rem', color: grey[600] }}>
							{season?.title ?? '시즌'} 판매 기간
						</Typography>
						<Typography sx={{ fontWeight: 600 }}>
							{season
								? `${dayjs(season.startDate).format('YYYY-MM-DD')} ~ ${dayjs(
										season.endDate,
								  ).format('YYYY-MM-DD')}`
								: '-'}
						</Typography>
					</Box>
					<Box sx={{ display: 'flex', gap: 2 }}>
						<Typography sx={{ width: '7rem', color: grey[600] }}>오늘</Typography>
						<Typography sx={{ fontWeight: 600 }}>
							{dayjs().format('YYYY-MM-DD')}
						</Typography>
					</Box>
				</Box>

				<Typography sx={{ color: grey[700], lineHeight: 1.7 }}>
					판매 기간에 포함된 시즌만 시작할 수 있습니다. 기간을 수정하거나 시작일이 지난
					뒤에 다시 시도하세요.
				</Typography>
			</DialogContent>

			<DialogActions sx={{ px: 3, pb: 2 }}>
				<Button onClick={onClose} variant="contained">
					확인
				</Button>
			</DialogActions>
		</Dialog>
	)
}
